module.exports = __webpack_public_path__ + "static/img/list-1.c0fd08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-1.png
// module id = lwZb
// module chunks = 1